<template>
    <v-text-field
        :value="value"
        :label="label"
        color="secondary"
        type="number"
        class="ma-3 mt-5"
        :hide-spin-buttons="false"
        outlined
        dense
        clearable
        :success="success"
        :error-messages="error"
        @focus="error = ''"
        @blur="validate"
        @input="$emit('input', $event)"
    ></v-text-field>
</template>

<script>
export default {
    name: "PriceField",

    props: {
        value: [String, Number],
        label: String,
        maxPrice: Number,
    },

    data: () => ({
        success: false,
        error: "",
        errorMessages: {
            priceRequired: {
                el: "Απαιτείται τιμή αγοράς",
                en: "Purchase price is required",
                it: "È richiesto il prezzo di acquisto",
            },
            priceMin: {
                el: "Η τιμή αγοράς πρέπει να είναι τουλάχιστον 0,1",
                en: "Purchase Price must be minimum 0.1",
                it: "Il prezzo di acquisto deve essere minimo 0,1",
            },
            priceMax: {
                el: "Η τιμή αγοράς δεν πρέπει να υπερβαίνει τα ",
                en: "Purchase Price must not exceed ",
                it: "Il prezzo di acquisto non deve superare ",
            },
        },
    }),

    computed: {
        lang() {
            return this.$route.params.lang;
        },
    },

    methods: {
        validateMaxPrice(){
            return !this.priceMax || Number(this.priceMax) <= Number(this.value)
        },

        validate() {
            if (!this.value) {
                this.error = this.errorMessages.priceRequired[this.lang];
            } else if (this.value < 0.1) {
                this.error = this.errorMessages.priceMin[this.lang];
            } else if ( !this.validateMaxPrice()) {
                this.error = this.errorMessages.priceMax[this.lang] + this.maxPrice + '€';
            } else {
                this.error = "";
            }
        },
        disableScrollChange(){
            if (document.activeElement.type === "number") {
                document.activeElement.blur();
            }
        },
     
    },


    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.success = val >= 0.1;
                this.$emit("get-transaction");
            },
        },
    },
    created() {
        document.addEventListener("wheel", this.disableScrollChange);
        document.addEventListener("mousewheel", this.disableScrollChange);
    },
};
</script>
